import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { type FormQuestionState, type ModuleId, type ModuleResult, QuestionType } from '@pixacare/forms';
import { FormDecorationComponent } from '@pixacare/forms-angular/ui';
import { TuiError } from '@taiga-ui/core';
import { ModuleResolverInputs } from '../../models/module-resolver-inputs';
import { FormManualTriggerComponent } from '../form-manual-trigger/form-manual-trigger.component';
import { FormQuestionInputComponent } from './form-question-input/form-question-input.component';
import { FormQuestionLabelComponent } from './form-question-label/form-question-label.component';

@Component({
  selector: 'pxc-form-question',
  templateUrl: './form-question.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-2',
    '[attr.data-testid]': 'question().id',
  },
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiError,
    FormManualTriggerComponent,
    FormQuestionInputComponent,
    FormQuestionLabelComponent,
    FormDecorationComponent,
  ],
})
export class FormQuestionComponent {
  readonly control = input.required<AbstractControl>();
  readonly moduleInputs = input.required<ModuleResolverInputs>();
  readonly question = input.required<FormQuestionState>();
  readonly readOnly = input<boolean>(false);

  readonly moduleReset = output<{ moduleId: ModuleId; targetId: string }>();
  readonly moduleTriggered = output<{ moduleId: ModuleId; targetId: string; result: ModuleResult }>();

  readonly QuestionType = QuestionType;

  readonly isReadOnly = computed(() => this.question().parameters?.readonly || this.readOnly());
  readonly hasErrors = computed(() => !this.question().isValid && this.question().errors?.length);
}
